import { useMutation } from 'react-query'
import { getPubnubToken } from '@services/requests/friendGroups'

export const useMutatePubnubToken = () => {
  return useMutation(() => {
    return getPubnubToken()
  })
}
